import { render, staticRenderFns } from "./GoBackHeader.vue?vue&type=template&id=0764c574&scoped=true"
import script from "./GoBackHeader.vue?vue&type=script&lang=ts"
export * from "./GoBackHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764c574",
  null
  
)

export default component.exports